import { getNavigationUrls } from '../config/navigation'

import { assignLocation } from './assignLocation'

export function redirectToPortal(path: string, locale: string) {
  const portalUrl = getNavigationUrls().portal
  assignLocation(`${portalUrl}/${locale}/${path}`)
}
